import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { PositionSlotAssignmentFormValues, PreviewPositionSlotListItem } from '../types';
import usePositionSlotsService from '../usePositionSlotsService';
import { getPositionSlotAssignmentFormSections } from './positionSlotAssignmentFormSections';
import { getPositionSlotAssignmentValidationSchema } from './positionSlotAssignmentValidation';

type PositionSlotAssignmentDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  positionSlot: PreviewPositionSlotListItem;
  onSuccess?: () => void | Promise<void>;
};

const PositionSlotAssignmentDrawer = ({
  isOpen,
  onClose,
  positionSlot,
  onSuccess,
}: PositionSlotAssignmentDrawerProps) => {
  const { updatePositionSlotAssignment } = usePositionSlotsService();
  const hasPositionFulfillmentRequest = Boolean(positionSlot.positionFulfillmentRequestId);
  const initialData: PositionSlotAssignmentFormValues = {
    employeeAlias: positionSlot.employeeAlias ?? positionSlot.employeeAliases?.[0] ?? null,
    requiredReplacement: hasPositionFulfillmentRequest || positionSlot.requiredReplacement,
  };

  return (
    <CreateEditFormDrawer
      key={`assign-${positionSlot.id}-${isOpen}`}
      isOpen={isOpen}
      onClose={onClose}
      title="Assign worker"
      width={600}
      initialData={initialData}
      submitFormFunc={data => updatePositionSlotAssignment(positionSlot, data as PositionSlotAssignmentFormValues)}
      getValidationSchemaFunc={getPositionSlotAssignmentValidationSchema}
      handleDirty={false}
      afterSubmit={{
        execute: async () => {
          await onSuccess?.();
          onClose();
        },
        message: 'Worker assignment has been successfully updated.',
      }}
      getSections={data =>
        getPositionSlotAssignmentFormSections(
          Boolean((data as PositionSlotAssignmentFormValues).employeeAlias),
          hasPositionFulfillmentRequest,
        )
      }
    />
  );
};

export default PositionSlotAssignmentDrawer;
